import * as React from "react";
import {
    HowItWorksItem
} from '~/components/homepage';

export default function HowItWorks(props: any) {
    return (
        <div className='HowItWorks'>
            <img className="HowItWorks__bg1" src="/assets/images/background/polygon.svg" alt=""/>
            <p className='InfoOurSite__title'><b>How it Works</b></p>
            <div className="HowItWorks__way">
                <HowItWorksItem 
                    img='console1.png'
                    title={<span>Read and Code in <b>one place</b></span>}
                    content='Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.'
                />
                <HowItWorksItem 
                    even
                    img='console2.png'
                    title={<span><b>Run</b> the examples for yourself</span>}
                    content='Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.'
                />
                <HowItWorksItem 
                    img='console3.png'
                    title={<span><b>Fiddle</b> with the code</span>}
                    content='Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.'
                />
                <HowItWorksItem 
                    even
                    img='console1.png'
                    title={<span><b>Solve</b> challenges</span>}
                    content='Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.'
                />
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/homepage/HowItWorks.tsx